import { actionTypes } from './actions';

export const initialState = {
  isVisible: false,
  orderId: null,
};

const cancelReasonDialogReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_CANCEL_REASON_DIALOG: {
      return {
        ...state,
        ...action.payload,
        isVisible: true,
      };
    }
    case actionTypes.HIDE_CANCEL_REASON_DIALOG: {
      return {
        ...state,
        isVisible: false,
      };
    }

    default:
      return state;
  }
};

export default cancelReasonDialogReducer;
